import { useLayoutEffect, useRef, useState } from "react";
import gsap from "gsap";
import { Card } from "../../components/card/card";
import "./projects.css";

import vika from "../../images/vika.webp";
import b2Play from "../../images/logo-b2-play.webp";
import reiki from "../../images/reiki.webp";
import vasky from "../../images/vasky.webp";

function Projects() {
  const viewportRef = useRef(null);
  const trackRef = useRef(null);
  const [index, setIndex] = useState(0);
  const [perView, setPerView] = useState(1);
  const gap = 24; // deve acompanhar o CSS

  const cardsProjeto = [
    {
      image: vika,
      name: "Vika Software",
      title: "Transformando Ideias em Soluções Digitais",
      // description: "Sócio da Vika Softwares: inovação em sistemas web, automações e soluções sob medida.",
      tags: ["React.js"],
      link: "https://www.vikasoftwares.com.br/",
    },
    {
      image: b2Play,
      name: "B2-pay",
      title: "Gestão de equipe e tarefas.",
      // description: "Solução para gestão financeira e transações.",
      tags: ["Ionic", "Zorro", "Nest.js", "PostgreSQL"],
      link: "https://b2play-mobile.vercel.app/#/login",
    },
    {
      image: vasky,
      name: "Vasky",
      title: "Delivery e Transporte",
      description: "",
      tags: ["Java Script", "Firebase"],
      link: "https://painel.vaskydelivery.com/",
    },
    {
      image: reiki,
      name: "Reiki",
      title: "Energia / conexão (vida, luz, fluxo, despertar)",
      // description: "",
      tags: ["React.js"],
      link: "#",
    },
    // Adicione mais objetos de card conforme necessário
  ];

  // calcula slides por view e reposiciona
  useLayoutEffect(() => {
    const viewport = viewportRef.current;
    const track = trackRef.current;
    if (!viewport || !track) return;

    const compute = () => {
      const w = viewport.clientWidth;
      const pv = w >= 1100 ? 3 : w >= 768 ? 2 : 1;
      setPerView(pv);

      // define largura dos slides
      const slideWidth = Math.floor((w - gap * (pv - 1)) / pv);
      track.querySelectorAll(".p-slide").forEach((el) => {
        el.style.width = `${slideWidth}px`;
      });

      // re-alinha posição atual
      const clampedIndex = Math.max(0, Math.min(index, cardsProjeto.length - pv));
      if (clampedIndex !== index) setIndex(clampedIndex);
      const x = -(slideWidth + gap) * clampedIndex;
      gsap.set(track, { x });
    };

    compute();
    const ro = new ResizeObserver(compute);
    ro.observe(viewport);
    window.addEventListener("resize", compute);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", compute);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index]);

  const slideTo = (next) => {
    const viewport = viewportRef.current;
    const track = trackRef.current;
    if (!viewport || !track) return;

    const w = viewport.clientWidth;
    const pv = perView;
    const slideWidth = Math.floor((w - gap * (pv - 1)) / pv);
    const maxIndex = Math.max(0, cardsProjeto.length - pv);
    const newIndex = Math.max(0, Math.min(next, maxIndex));
    setIndex(newIndex);
    const x = -(slideWidth + gap) * newIndex;
    gsap.to(track, { x, duration: 0.55, ease: "power3.out" });
  };

  const next = () => slideTo(index + 1);
  const prev = () => slideTo(index - 1);

  return (
    <section
      id="projects"
      className="s-project target-section"
      data-aos="fade-up"
      data-aos-delay="120"
    >
      <header className="section-header">
        <span className="section-eyebrow">Portfólio selecionado</span>
        <h2 className="section-title">Projetos</h2>
        <p className="section-subtitle">
          Estudos de caso que destacam produtos digitais construídos com foco em valor de negócio, performance e experiência.
        </p>
      </header>
      <div className="p-carousel" aria-roledescription="carousel">
        <button className="p-nav p-prev" onClick={prev} aria-label="Anterior">‹</button>
        <div className="p-viewport" ref={viewportRef}>
          <div className="p-track" ref={trackRef} style={{ gap: `${gap}px` }}>
            {cardsProjeto.map((card, i) => (
              <div className="p-slide" key={i}>
                <Card
                  image={card.image}
                  name={card.name}
                  title={card.title}
                  description={card.description}
                  link={card.link}
                  tags={card.tags}
                />
              </div>
            ))}
          </div>
        </div>
        <button className="p-nav p-next" onClick={next} aria-label="Próximo">›</button>
      </div>
    </section>
  );
}

export default Projects;
